import { TabStyles } from '@tableau/widgets';
import { style } from 'typestyle';
import { NestedCSSProperties } from 'typestyle/lib/types';

import { SettingsStyles, wideWidth } from '~src/settings/styles/CommonStyles';

var customDomainSizeUnit = 5;
var customDomainSpaceUnit = customDomainSizeUnit;

export const CustomDomainHeader = style({
    ...SettingsStyles.settingsGroupNameProperties,
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingBottom: TabStyles.Spacing.SmallSpace,
    margin: 0,
  });

export const labelTextStyle: NestedCSSProperties = {
    paddingTop: TabStyles.Spacing.MediumSpace,
  };

export const clockIconStyle = style({
    ...labelTextStyle,
    paddingRight:  TabStyles.Spacing.SmallSpace
  });

export const intermediateDomainwarningStyle = style({
  ...labelTextStyle,
    color: 'red'
  });

export const intermediateDomainTextStyle = style({
    ...labelTextStyle,
  });

export const successIconStyle = style({
    width: customDomainSizeUnit*5,
    height: customDomainSizeUnit*5,
    marginTop: TabStyles.Spacing.LargeSpace,
  });

export const unavailableIconStyle = style({
    width: customDomainSizeUnit*4,
    height: customDomainSizeUnit*4,
    marginTop: TabStyles.Spacing.LargeSpace,
  });

export const customDomainSubHeaderStyle = style({
    marginTop: TabStyles.Spacing.LargeSpace + customDomainSpaceUnit,
    paddingLeft: TabStyles.Spacing.MediumSpace,
    fontSize: TabStyles.Typography.Sizing.Large
  });

  export const customDomainContentStyle = style({
    paddingLeft: TabStyles.Spacing.MediumSpace + customDomainSpaceUnit*5,
    display: 'flex',
    position: 'relative'
  });

  export const customDomainButtonStyle = style({
    position: 'absolute',
    bottom: 0,
    right: 0
  });

export const customDomainHeaderContainer = style({
    display: 'flex'
  });

  export const configuredSettingHeaderStyle = style({
    marginTop: TabStyles.Spacing.LargeSpace + customDomainSpaceUnit,
    fontSize: TabStyles.Typography.Sizing.Large
  });

  export const configuredSettingContentStyle = style({
    marginTop: TabStyles.Spacing.MediumSpace,
  });

  export const configuredSettingValueStyle = style({
    marginTop: TabStyles.Spacing.SmallSpace,
    display: 'flex',
    position: 'relative'
  });

  export const configuredSettingButtonStyle = style({
    marginRight: TabStyles.Spacing.MediumSpace,
  });

  export const customDomainWideField= style({
    ...wideWidth,
    // use nested styles to make the inputs match the parent's width, because the widget does not do that by default
    '$nest': {
      '& input': {
        ...wideWidth,
      },
    },
  });